import React from 'react';

function VersionInfo() {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 36,
        right: '0px',
        padding: '10px',
        opacity: 0.5,
        userSelect: 'none',
        zIndex: 9999,
        fontSize: '12px',
        pointerEvents: 'none',
      }}
    >
      v{global.appVersion || '0.0.0'}
    </div>
  );
}

export default VersionInfo;
